
export const BASE_URL = "https://retail-heidi-yashvardhan-3f5a7e33.koyeb.app/api/v1";